<template>
  <!-- HEADER Story: CD-2, CD-3-->
  <div class="w-full border-b border-grey-light-200 bg-white fixed top-0 left-0 right-0 z-20">
    <navbar-component
      :show-mobile-sidebar="showMobileSidebar"
      :show-desktop-sidebar="showDesktopSidebar"
      @open-mobile-sidebar="showMobileSidebar = true"
      @close-mobile-sidebar="showMobileSidebar = false"
      @open-desktop-sidebar="showDesktopSidebar = true"
      @close-desktop-sidebar="showDesktopSidebar = false"
      @sign-out="onSignOut"
    />
  </div>

  <!-- MOBILE SIDEBAR  --->
  <mobile-sidebar
    v-if="isMobile || isTablet"
    :open="showMobileSidebar"
    @close="showMobileSidebar = false"
    @sign-out="onSignOut"
  />

  <!-- DESKTOP SIDEBAR  --->
  <desktop-sidebar
    v-if="isDesktop"
    :open="showDesktopSidebar"
    :fullName="fullName"
    :email="email"
    @close="showDesktopSidebar = false"
    @sign-out="onSignOut"
  />

  <!-- MAIN CONTENT -->
  <div
    class="p-4 mt-[72px] min-h-screen"
    :class="{ 'ml-[85px] pr-[20px]': isDesktop, 'pl-[250px]': showDesktopSidebar && isDesktop }"
  >
    <router-view />
  </div>

  <!-- OVERLAY -->
  <div
    v-if="showMobileSidebar"
    class="fixed top-[72px] bottom-16 left-0 right-0 z-40 bg-gray-100/80"
    @click="showMobileSidebar = false"
  />

  <!-- MOBILE BOTTOM NAVIGATION -->
  <mobile-bottom-nav v-if="isMobile || isTablet" />
</template>

<script setup lang="ts">
import MobileBottomNav from '@/components/shopper/BottomNav.vue';
import DesktopSidebar from '@/components/shopper/DesktopSidebar.vue';
import MobileSidebar from '@/components/shopper/MobileSidebar.vue';
import NavbarComponent from '@/components/shopper/NavbarComponent.vue';
import { useUserStore } from '@/stores/users';
import { useBreakpoint } from '@/utils/useBreakPoint';
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';

const { isMobile, isDesktop, isTablet } = useBreakpoint();
const userStore = useUserStore();
const router = useRouter();

const showMobileSidebar = ref(false);
const showDesktopSidebar = ref(true);
const fullName = ref('Layup Customer');
const email = ref('N/A');

onMounted(() => {
  const user = userStore.user;
  if (user?.name) {
    fullName.value = user.name;
  }
  if (user?.email) {
    email.value = user.email;
  }
});

const onSignOut = async () => {
  await userStore.signOut();
  await router.push({ name: 'shopperSignIn' });
};
</script>
